const {
  VUE_APP_apiKey,
  VUE_APP_authDomain,
  VUE_APP_projectId,
  VUE_APP_storageBucket,
  VUE_APP_messagingSenderId,
  VUE_APP_measurementId,
  VUE_APP_appId,
  VUE_APP_cmsUrl,
  VUE_APP_cmsAppName,
  VUE_APP_cmsClientId,
  VUE_APP_cmsClientSecret
} = process.env

export const FIREBASE_API_KEY = VUE_APP_apiKey
export const FIREBASE_AUTH_DOMAIN = VUE_APP_authDomain
export const FIREBASE_PROJECT_ID = VUE_APP_projectId
export const FIREBASE_STORAGE_BUCKET = VUE_APP_storageBucket
export const FIREBASE_MESSAGING_SENDER_ID = VUE_APP_messagingSenderId
export const FIREBASE_APP_ID = VUE_APP_appId
export const FIREBASE_MEASUREMENT_ID = VUE_APP_measurementId
export const CMS_URL = VUE_APP_cmsUrl
export const CMS_CLIENT_ID = VUE_APP_cmsClientId
export const CMS_CLIENT_SECRET = VUE_APP_cmsClientSecret
export const CMS_APP_NAME = VUE_APP_cmsAppName
